import { sendStorefrontActivity, sendStorefrontActivityKeepalive } from "../api/activity";
import {
  getPreviousStorefrontPath,
  nextStorefrontJourneyStep,
  setCurrentStorefrontPath,
} from "./storefrontActivityIdentity";

const recentEvents = new Map();

function dedupeKey(action, metadata) {
  return [
    action,
    metadata?.productId || "",
    metadata?.path || metadata?.route || "",
    metadata?.href || "",
  ].join(":");
}

function currentPath(metadata = {}) {
  if (metadata.path) return metadata.path;
  if (metadata.route) return metadata.route;
  if (typeof window === "undefined") return "";
  return `${window.location.pathname}${window.location.hash}`;
}

export function trackStorefrontActivity(action, metadata = {}, options = {}) {
  if (typeof window === "undefined" || !action) return Promise.resolve(null);
  const key = dedupeKey(action, metadata);
  const now = Date.now();
  const dedupeMs = Number(options.dedupeMs ?? 2500);
  const previous = recentEvents.get(key) || 0;
  if (dedupeMs > 0 && now - previous < dedupeMs) return Promise.resolve(null);
  recentEvents.set(key, now);
  for (const [eventKey, timestamp] of recentEvents.entries()) {
    if (now - timestamp > 60_000) recentEvents.delete(eventKey);
  }

  const identity = nextStorefrontJourneyStep();
  const path = currentPath(metadata);
  const previousPath = metadata.previousPath ?? getPreviousStorefrontPath();
  const payload = {
    action,
    visitorId: identity.visitorId,
    sessionId: identity.sessionId,
    tabId: identity.tabId,
    step: identity.step,
    journey: {
      channel: "storefront",
      visitorId: identity.visitorId,
      sessionId: identity.sessionId,
      tabId: identity.tabId,
      step: identity.step,
      path,
      previousPath,
      durationMs: Math.max(0, Number(metadata.durationMs || 0)),
      scrollPercent: Math.max(0, Math.min(100, Number(metadata.scrollPercent || 0))),
    },
    metadata: {
      ...metadata,
      path,
      pageTitle: document.title || "",
      viewport: `${window.innerWidth}x${window.innerHeight}`,
    },
  };

  if (action !== "page_exit") setCurrentStorefrontPath(path);
  const sender = options.keepalive ? sendStorefrontActivityKeepalive : sendStorefrontActivity;
  return sender(payload).catch(() => null);
}
